import React from "react";
import "../../Assessts/Styles/AboutUs.scss";
import AUB from "../../Assessts/Images/AboutUs/AUB.png";

import SAboutus from "../../ReUableComponents/SmallAboutus";

import FAQS from "../../ReUableComponents/FAQS";


import SAO from "../../Assessts/Images/Home/SAO.svg";
import CEAbout from "../../Assessts/Images/AboutUs/CE-About.png";
import IOText from "../../ReUableComponents/ImageOntext";

import CEPDF from "../../Assessts/Images/Home/CheckEligilibity.pdf";

import AUSTypes from "./Scholarshiptypes";
const CBLerning = () => {
    return (<div className="AboutUs-MainDiv mt-2">
        <IOText Image={AUB} Alt="EMpower" Text={<div className="Text-MainDiv ">
            <div className="w-100"> Advancing Education by <span style={{ color: "#F7D670" }}>Supporting Meritorious and Deserving Students</span></div>
        </div>} />
        <SAboutus />
        <AUSTypes />
        <FAQS />

        <div className="pt-3 pb-4 dflex JCCenter flexd-column alignitems gap-3" style={{ backgroundColor: "#F6F2ED" }}>
            <div className="Web-MainHeading">Ready to Apply for a Scholarship?</div>
            <div>Review the eligibility criteria and submit your application to access merit-based educational support.</div>
            <div className="dflex  gap-3 JMD-About">
                <button className="Website-Buttons "
                onClick={() => window.open("https://portal.northsouth.org/app6/MainTest.aspx?_gl=1*1k6hnm5*_ga*MTEzODQwNjc1MS4xNzQ4ODM5Njgz*_ga_NFGY5F210T*czE3NzAzNzM4MTMkbzMwJGcxJHQxNzcwMzc0NDY4JGo0OCRsMCRoMTkxNzc4OTA1Mw..", "_blank")}><img src={SAO} alt="Apply Now" className="h-50" /> Apply Now</button>
                <button className="Website-Buttons " onClick={() => window.open(CEPDF, "_blank")}><img src={CEAbout} alt="CE-About" className="h-75" /> Check Eligibility </button>
            </div>
        </div>
    </div>)
}
export default CBLerning;